import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import EnhancementHistory from 'components/EnhancementHistory'
import HandlerSelect from 'components/HandlerSelect'
import ImageInput from 'components/ImageInput'
import { HandlerOption } from 'types/Handlers'
import c from './IdleStage.module.scss'

interface IdleStageProps {
  handler: HandlerOption
  handlerOptions: HandlerOption[]
  onHandlerChange: (newHandler: HandlerOption) => void
  onImageChange: (newFile: File) => void
}

function IdleStage({
  handler,
  handlerOptions,
  onHandlerChange,
  onImageChange,
}: IdleStageProps) {
  const { t } = useTranslation()

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0]
      if (file) onImageChange(file)
    },
    [onImageChange],
  )

  return (
    <>
      <EnhancementHistory />
      <div className={`bottom ${c.bottom}`}>
        <HandlerSelect
          handler={handler}
          handlerOptions={handlerOptions}
          onHandlerChange={onHandlerChange}
        />
        <ImageInput
          className={c.input}
          label={t('stages.enhancement.idle.buttonText')}
          onChange={handleInputChange}
        />
      </div>
    </>
  )
}

export default IdleStage
